export const MENU_API = '/menu'
export const CONTACT_API = '/contact'
export const PARTNERS_API = '/partner'
export const NEWSLETTER_API = '/newsletter'
export const MAIN_API = '/main'
export const NEWS_API = '/news'
export const EVENTS_API = '/event'